import dayjs from '@/plugins/dayjs'
import { DateFormat, OemDomain, OemName } from '@/utils/constants'

export const formatUuid = (id: string): string => {
  return (
    id.slice(0, 8) +
    '-' +
    id.slice(8, 12) +
    '-' +
    id.slice(12, 16) +
    '-' +
    id.slice(16, 20) +
    '-' +
    id.slice(20)
  )
}

/**
 * 日付をフォーマットする。
 *
 * @param date 日付オブジェクト、または日付文字列、または日付ミリ秒
 * @param dateFormat 日付フォーマット(未指定の場合は YYYY/MM/DD とする)
 * @return フォーマット後の日付文字列(不正な日付を指定した場合は空文字を返却する)
 */
export const formatDate = (
  date: Date | string | number = '',
  dateFormat: DateFormat = DateFormat.YYYY_MM_DD
): string => {
  const day = dayjs(date)
  if (!day.isValid()) return ''
  return day.format(dateFormat)
}

// ドメインチェック
export const oemDomain = () => {
  const hostname = new URL(window.location.href).hostname
  if (hostname.includes(OemDomain.Zeromedical) || hostname.includes(OemDomain.ZeromedicalMarch))
    return OemName.Zeromedical
  if (hostname.includes(OemDomain.WellMedi) || hostname.includes(OemDomain.WellMediMarch))
    return OemName.WellMedi
  return OemName.March
}

// favicon更新
export const updateFavicon = (_oem: string) => {
  const faviconSizes: { size: string; file: string }[] = [
    { size: '16x16', file: '/favicon16.ico' },
    { size: '24x24', file: '/favicon24.ico' },
    { size: '32x32', file: '/favicon32.ico' },
    { size: '48x48', file: '/favicon48.ico' },
  ]
  // 既存のfaviconタグをすべて削除
  document.querySelectorAll('link[rel=\'icon\']').forEach((el) => el.remove())
  // サイズ別にfaviconタグを追加
  faviconSizes.forEach(({ size, file }) => {
    const link = document.createElement('link')
    link.rel = 'icon'
    link.type = 'image/x-icon'
    link.setAttribute('sizes', size)
    link.href = file
    document.head.appendChild(link)
  })
}
